<template>
<div class="box">
  <div>

    <div class="row mt-3">
      <div class="col-12 pb-1 border-bottom">
        <h5 class="h5-sor">超级穿透 <small class="text-muted">(请先阅读下方说明)</small></h5>
      </div>
    </div>

    <div class="row mb-3 px-1 py-1" id="buy">
      <form id="protocolForm" class="w-100 mt-3" action="/user/protocol" method="post">

        <div class="pl-2">
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">当前状态</label>
            <div class="col-sm-10 col-form-label" id="protocolText">
              {{status}}                       </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-2 col-form-label">超级穿透模式</label>
            <div class="col-sm-10" style="display: flex;align-items: center;">
                <b-form-checkbox v-model="checked" name="check-button" style="zoom: 1.2" switch size="large">

                </b-form-checkbox>
              超级穿透
            </div>
          </div>

          <div class="mt-2">&nbsp;</div>
          <p class="font-weight-light font-italic">超级穿透模式，适用于客户端无法连接到服务器，或连接后经常断开的情况。正常使用情况下，无需开启；</p>
          <p class="font-weight-light font-italic">开启超级穿透模式后，您的网络速度将会下降，延迟会变高。</p>

        </div>

        <input type="hidden" name="_csrf-vps" value="Tl95aHo3YVM.NBVaFgYKAwcxFB0bBioafx4JCkxOCiokDwE/S14wHw==">

        <br>
        <br>

      </form>
    </div>



  </div>
  <footerPage></footerPage>
</div>
</template>

<script>
import footerPage from "@/components/userInfo/footer";
export default {
  name: "superPenetration",
  components:{footerPage},
  data(){
    return{
      status:'正常状态',
      checked:false,
    }
  }
}
</script>

<style scoped>
::v-deep .footer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
@media (min-width: 768px) {
  .h5-sor {
    font-size: 2rem;
  }

  .account-info {
    font-size: 1rem;
  }

  .account-info > dt {
    padding-right: 0;
  }

  .container-md {
    max-width: 960px;
  }
}
</style>